export default __webpack_public_path__ + "static/feedback--mobile@1x-2db8569f349b6be233d0700375a7513b.webp";